import { ICustomField } from '../../../interfaces/ICustomField'
import { ApplicationTagEventStatusArray } from '../../../interfaces/IApplicationTag'
import { ApplicationTagActionArray } from '../../../interfaces/IApplicationTagAction'

export namespace ProcessTagConstants {
  /**
   * Custom settings fields
   */
  export const EVENT_CUSTOM_FIELDS: ICustomField = {
    label: 'Process Tags Automations',
    type: 'list',
    fields: [
      {
        label: 'Inquiry Status',
        name: 'status_key',
        type: 'select',
        options: ApplicationTagEventStatusArray.map(type => {
          return {
            label: type,
            value: type
          }
        }) as any
      },
      {
        label: 'Automation Trigger',
        name: 'action_key',
        type: 'select',
        options: ApplicationTagActionArray.map(type => {
          return {
            label: type,
            value: type
          }
        }) as any
      },
      {
        label: 'New Process Tag',
        name: 'tag_uuid',
        type: 'select',
        options: []
      }
    ]
  }
}
